module.exports = {
  1: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  31: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  41: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  56: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  97: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  137: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  8453: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  17000: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  42161: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  43113: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  43114: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  59140: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  59144: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  80001: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  84532: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  421614: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  11155111: '0x01b28Aa66a54c6F2bE5C2eF905A2329270CCa96F',
  245022926: '0x4105D956607D6784A9E6d3921AF75353Ee861202',
  245022934: '0x7b3bb0516376b279bC94fd36c6Fb521A16803C3C',
}
